// extracted by mini-css-extract-plugin
export default {"countdown":"w0-z","srOnly":"x0-z"};